import { Icon, SkeletonDots } from '@yes.technology/react-toolkit'
import useDocumentLink from 'document/shared/hooks/useDocumentLink'
import { useMemo } from 'react'
import ImagePreview from './ImagePreview'
import { TableDocumentPreviewContainer } from './TableDocumentPreview.styles'
import type { TableDocumentPreviewProps } from './TableDocumentPreview.types'
import {
  getContentType,
  getMostRecentDocument,
  previewIcons
} from './TableDocumentPreview.utils'

const TableDocumentPreview = ({ documents }: TableDocumentPreviewProps) => {
  const documentToShow = useMemo(
    () => getMostRecentDocument(documents ?? []),
    [documents]
  )

  const documentUuid = documentToShow?.uuid ?? ''

  const { data: fileUrl, isLoading } = useDocumentLink({
    uuid: documentUuid,
    type: 'document'
  })

  if (isLoading)
    return (
      <TableDocumentPreviewContainer>
        <SkeletonDots size={3} />
      </TableDocumentPreviewContainer>
    )

  if (!documentToShow || !fileUrl) return null

  const contentType = getContentType(documentToShow)
  const previewIcon = previewIcons[contentType]

  return (
    <TableDocumentPreviewContainer>
      {contentType === 'image' ? (
        <ImagePreview
          src={fileUrl}
          fallBackIcon={previewIcon}
          alt='Preview of the document'
        />
      ) : (
        <Icon iconName={previewIcon} icSize='large' icColor='primary' />
      )}
    </TableDocumentPreviewContainer>
  )
}

export default TableDocumentPreview
